import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import {
  ContextMenuComponent,
  MasterComponent,
  MasterDetailComponent,
  PanelComponent,
  TitleComponent,
} from '@rocksoft/cdk';
import { GroupPermissionsEntityListContainerComponent } from './group-permissions-entity-list.container';

@Component({
  selector: 'era-security-group-permissions-view',
  templateUrl: './group-permissions-view.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MasterDetailComponent,
    MasterComponent,
    PanelComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    RouterLink,
    GroupPermissionsEntityListContainerComponent,
  ],
})
export class GroupPermissionsViewContainerComponent {}
